import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../src/app/store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../src/app/store/promotions/index.ts'), 'promotions/index.ts')
  resolveStoreModules(require('../src/app/store/bookings/index.ts'), 'bookings/index.ts')
  resolveStoreModules(require('../src/app/store/plugins/index.ts'), 'plugins/index.ts')
  resolveStoreModules(require('../src/app/store/bedrooms/index.js'), 'bedrooms/index.js')
  resolveStoreModules(require('../src/app/store/payments/index.js'), 'payments/index.js')
  resolveStoreModules(require('../src/app/store/notifications/index.ts'), 'notifications/index.ts')
  resolveStoreModules(require('../src/app/store/jss/index.ts'), 'jss/index.ts')
  resolveStoreModules(require('../src/app/store/user/index.js'), 'user/index.js')
  resolveStoreModules(require('../src/app/store/inquiries/index.ts'), 'inquiries/index.ts')
  resolveStoreModules(require('../src/app/store/rate_plans/index.ts'), 'rate_plans/index.ts')
  resolveStoreModules(require('../src/app/store/events/index.js'), 'events/index.js')
  resolveStoreModules(require('../src/app/store/rooms/index.ts'), 'rooms/index.ts')
  resolveStoreModules(require('../src/app/store/hotels/index.ts'), 'hotels/index.ts')
  resolveStoreModules(require('../src/app/store/availability_rates/index.ts'), 'availability_rates/index.ts')
  resolveStoreModules(require('../src/app/store/houses/index.ts'), 'houses/index.ts')
  resolveStoreModules(require('../src/app/store/availabilities/index.ts'), 'availabilities/index.ts')
  resolveStoreModules(require('../src/app/store/support/index.js'), 'support/index.js')
  resolveStoreModules(require('../src/app/store/venues/index.ts'), 'venues/index.ts')
  resolveStoreModules(require('../src/app/store/availabilities/state.ts'), 'availabilities/state.ts')
  resolveStoreModules(require('../src/app/store/venues/getters.ts'), 'venues/getters.ts')
  resolveStoreModules(require('../src/app/store/availabilities/getters.ts'), 'availabilities/getters.ts')
  resolveStoreModules(require('../src/app/store/venues/actions.ts'), 'venues/actions.ts')
  resolveStoreModules(require('../src/app/store/notifications/state.ts'), 'notifications/state.ts')
  resolveStoreModules(require('../src/app/store/notifications/mutations.ts'), 'notifications/mutations.ts')
  resolveStoreModules(require('../src/app/store/bookings/actions.ts'), 'bookings/actions.ts')
  resolveStoreModules(require('../src/app/store/notifications/getters.ts'), 'notifications/getters.ts')
  resolveStoreModules(require('../src/app/store/notifications/actions.ts'), 'notifications/actions.ts')
  resolveStoreModules(require('../src/app/store/jss/state.ts'), 'jss/state.ts')
  resolveStoreModules(require('../src/app/store/jss/mutations.ts'), 'jss/mutations.ts')
  resolveStoreModules(require('../src/app/store/bookings/getters.ts'), 'bookings/getters.ts')
  resolveStoreModules(require('../src/app/store/jss/getters.ts'), 'jss/getters.ts')
  resolveStoreModules(require('../src/app/store/jss/actions.ts'), 'jss/actions.ts')
  resolveStoreModules(require('../src/app/store/venues/state.ts'), 'venues/state.ts')
  resolveStoreModules(require('../src/app/store/availabilities/actions.ts'), 'availabilities/actions.ts')
  resolveStoreModules(require('../src/app/store/inquiries/state.ts'), 'inquiries/state.ts')
  resolveStoreModules(require('../src/app/store/inquiries/mutations.ts'), 'inquiries/mutations.ts')
  resolveStoreModules(require('../src/app/store/bookings/mutations.ts'), 'bookings/mutations.ts')
  resolveStoreModules(require('../src/app/store/bookings/state.ts'), 'bookings/state.ts')
  resolveStoreModules(require('../src/app/store/plugins/loginOnUnauthorized.ts'), 'plugins/loginOnUnauthorized.ts')
  resolveStoreModules(require('../src/app/store/availabilities/mutations.ts'), 'availabilities/mutations.ts')
  resolveStoreModules(require('../src/app/store/venues/mutations.ts'), 'venues/mutations.ts')
  resolveStoreModules(require('../src/app/store/inquiries/actions.ts'), 'inquiries/actions.ts')
  resolveStoreModules(require('../src/app/store/inquiries/getters.ts'), 'inquiries/getters.ts')
  resolveStoreModules(require('../src/app/store/user/account/index.js'), 'user/account/index.js')
  resolveStoreModules(require('../src/app/store/jss/types/index.ts'), 'jss/types/index.ts')
  resolveStoreModules(require('../src/app/store/user/profile/index.js'), 'user/profile/index.js')
  resolveStoreModules(require('../src/app/store/content/tours/index.js'), 'content/tours/index.js')
  resolveStoreModules(require('../src/app/store/content/rules/index.js'), 'content/rules/index.js')
  resolveStoreModules(require('../src/app/store/user/occupations/index.js'), 'user/occupations/index.js')
  resolveStoreModules(require('../src/app/store/content/pages/index.js'), 'content/pages/index.js')
  resolveStoreModules(require('../src/app/store/payments/cards/index.js'), 'payments/cards/index.js')
  resolveStoreModules(require('../src/app/store/payments/customers/index.js'), 'payments/customers/index.js')
  resolveStoreModules(require('../src/app/store/payments/forms/index.js'), 'payments/forms/index.js')
  resolveStoreModules(require('../src/app/store/content/notes/index.js'), 'content/notes/index.js')
  resolveStoreModules(require('../src/app/store/events/bookings/index.js'), 'events/bookings/index.js')
  resolveStoreModules(require('../src/app/store/content/faqs/index.js'), 'content/faqs/index.js')
  resolveStoreModules(require('../src/app/store/user/membership/index.js'), 'user/membership/index.js')
  resolveStoreModules(require('../src/app/store/content/categories/index.js'), 'content/categories/index.js')
  resolveStoreModules(require('../src/app/store/events/categories/index.js'), 'events/categories/index.js')
  resolveStoreModules(require('../src/app/store/bedrooms/promotions/index.js'), 'bedrooms/promotions/index.js')
  resolveStoreModules(require('../src/app/store/user/interests/index.js'), 'user/interests/index.js')
  resolveStoreModules(require('../src/app/store/bedrooms/bookings/index.js'), 'bedrooms/bookings/index.js')
  resolveStoreModules(require('../src/app/store/events/events/index.js'), 'events/events/index.js')
  resolveStoreModules(require('../src/app/store/bedrooms/availabilities/index.js'), 'bedrooms/availabilities/index.js')
  resolveStoreModules(require('../src/app/store/user/communication-preferences/index.js'), 'user/communication-preferences/index.js')
  resolveStoreModules(require('../src/app/store/applications/submissions/index.ts'), 'applications/submissions/index.ts')
  resolveStoreModules(require('../src/app/store/content/perks/index.ts'), 'content/perks/index.ts')
  resolveStoreModules(require('../src/app/store/support/inquiries/index.js'), 'support/inquiries/index.js')
  resolveStoreModules(require('../src/app/store/applications/products/index.ts'), 'applications/products/index.ts')
  resolveStoreModules(require('../src/app/store/ui/environment/index.ts'), 'ui/environment/index.ts')
  resolveStoreModules(require('../src/app/store/applications/attachments/index.ts'), 'applications/attachments/index.ts')
  resolveStoreModules(require('../src/app/store/ui/modals/index.ts'), 'ui/modals/index.ts')
  resolveStoreModules(require('../src/app/store/applications/applications/index.ts'), 'applications/applications/index.ts')
  resolveStoreModules(require('../src/app/store/user/account-verification-emails/index.js'), 'user/account-verification-emails/index.js')
  resolveStoreModules(require('../src/app/store/user/identity/index.js'), 'user/identity/index.js')
  resolveStoreModules(require('../src/app/store/applications/products/state.ts'), 'applications/products/state.ts')
  resolveStoreModules(require('../src/app/store/applications/submissions/actions.ts'), 'applications/submissions/actions.ts')
  resolveStoreModules(require('../src/app/store/applications/submissions/getters.ts'), 'applications/submissions/getters.ts')
  resolveStoreModules(require('../src/app/store/events/bookings/constants.js'), 'events/bookings/constants.js')
  resolveStoreModules(require('../src/app/store/applications/applications/state.ts'), 'applications/applications/state.ts')
  resolveStoreModules(require('../src/app/store/applications/submissions/mutations.ts'), 'applications/submissions/mutations.ts')
  resolveStoreModules(require('../src/app/store/applications/submissions/state.ts'), 'applications/submissions/state.ts')
  resolveStoreModules(require('../src/app/store/events/bookings/state.js'), 'events/bookings/state.js')
  resolveStoreModules(require('../src/app/store/applications/attachments/actions.ts'), 'applications/attachments/actions.ts')
  resolveStoreModules(require('../src/app/store/applications/attachments/getters.ts'), 'applications/attachments/getters.ts')
  resolveStoreModules(require('../src/app/store/applications/applications/getters.ts'), 'applications/applications/getters.ts')
  resolveStoreModules(require('../src/app/store/events/events/constants.js'), 'events/events/constants.js')
  resolveStoreModules(require('../src/app/store/applications/applications/actions.ts'), 'applications/applications/actions.ts')
  resolveStoreModules(require('../src/app/store/content/notes/constants.js'), 'content/notes/constants.js')
  resolveStoreModules(require('../src/app/store/applications/attachments/mutations.ts'), 'applications/attachments/mutations.ts')
  resolveStoreModules(require('../src/app/store/applications/attachments/state.ts'), 'applications/attachments/state.ts')
  resolveStoreModules(require('../src/app/store/applications/products/actions.ts'), 'applications/products/actions.ts')
  resolveStoreModules(require('../src/app/store/events/events/state.js'), 'events/events/state.js')
  resolveStoreModules(require('../src/app/store/applications/products/getters.ts'), 'applications/products/getters.ts')
  resolveStoreModules(require('../src/app/store/content/notes/state.js'), 'content/notes/state.js')
  resolveStoreModules(require('../src/app/store/applications/applications/mutations.ts'), 'applications/applications/mutations.ts')
  resolveStoreModules(require('../src/app/store/content/perks/actions.ts'), 'content/perks/actions.ts')
  resolveStoreModules(require('../src/app/store/content/perks/getters.ts'), 'content/perks/getters.ts')
  resolveStoreModules(require('../src/app/store/ui/environment/actions.ts'), 'ui/environment/actions.ts')
  resolveStoreModules(require('../src/app/store/ui/environment/getters.ts'), 'ui/environment/getters.ts')
  resolveStoreModules(require('../src/app/store/applications/products/mutations.ts'), 'applications/products/mutations.ts')
  resolveStoreModules(require('../src/app/store/ui/environment/mutations.ts'), 'ui/environment/mutations.ts')
  resolveStoreModules(require('../src/app/store/ui/environment/queries.ts'), 'ui/environment/queries.ts')
  resolveStoreModules(require('../src/app/store/ui/environment/state.ts'), 'ui/environment/state.ts')
  resolveStoreModules(require('../src/app/store/ui/environment/transformations.ts'), 'ui/environment/transformations.ts')
  resolveStoreModules(require('../src/app/store/content/perks/mutations.ts'), 'content/perks/mutations.ts')
  resolveStoreModules(require('../src/app/store/content/perks/state.ts'), 'content/perks/state.ts')
  resolveStoreModules(require('../src/app/store/events/events/mutations/index.js'), 'events/events/mutations/index.js')
  resolveStoreModules(require('../src/app/store/events/events/getters/index.js'), 'events/events/getters/index.js')
  resolveStoreModules(require('../src/app/store/content/notes/actions/index.js'), 'content/notes/actions/index.js')
  resolveStoreModules(require('../src/app/store/content/notes/getters/index.js'), 'content/notes/getters/index.js')
  resolveStoreModules(require('../src/app/store/events/bookings/mutations/index.js'), 'events/bookings/mutations/index.js')
  resolveStoreModules(require('../src/app/store/content/notes/mutations/index.js'), 'content/notes/mutations/index.js')
  resolveStoreModules(require('../src/app/store/events/bookings/actions/index.js'), 'events/bookings/actions/index.js')
  resolveStoreModules(require('../src/app/store/events/events/actions/index.js'), 'events/events/actions/index.js')
  resolveStoreModules(require('../src/app/store/events/bookings/getters/index.js'), 'events/bookings/getters/index.js')
  resolveStoreModules(require('../src/app/store/events/events/mutations/filters.js'), 'events/events/mutations/filters.js')
  resolveStoreModules(require('../src/app/store/events/events/getters/filters.js'), 'events/events/getters/filters.js')
  resolveStoreModules(require('../src/app/store/events/events/actions/filters/index.js'), 'events/events/actions/filters/index.js')
  resolveStoreModules(require('../src/app/store/content/notes/getters/mocks/latest-notes-mock.js'), 'content/notes/getters/mocks/latest-notes-mock.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const storeModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(storeModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
